import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

export default function free4Box(props) {

  // 모듈러 링크 리액트 hook
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a, b, c,d) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    let contentId;
    let contentTitle;
    let conver_current_s = (parseInt(d) + 1);

//    alert('www== ' + conver_current_s);

    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '상단영역_자유형(4개)',
        clickType: 'NC',
        value1: b.pc_img_attr,
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };



  return (
    <div className="swiper-slide slide-slide">
      <div className="swiper-cont">
        <div className="spotModuleGroup2">
          {
            props.data.map((item, index) => {

              return (
                <div key={'mtf4_' + index} className={`spotModuleWrap_freeType2 spotModuleWrap_ContentPhoto ${item.title == '' || item.title == null ? 'type_noText' : ''}`}>
                  {
                    item.link_url == null || item.link_url == ''
                      ? (
                        <>
                          <div className="spotModuleLink">
                            <span className="spotModuleImage_w">
                              <img src={item.m_img_url} className="spotModuleImg" alt={item.m_img_attr} />
                              {/* <Image
                                src={item.m_img_url}
                                className="spotModuleImg"
                                layout='fill'
                                width={162}
                                height={258}
                                quality={props.data.imageQuality || 75}
                                alt={props.data.m_img_attr}
                              /> */}
                            </span>
                            <div className="spotProgramCont">
                              <strong className="spotProgram-Title">{item.title}</strong>
                            </div>
                          </div>
                        </>
                      )
                      :
                      (
                        <>
                          <a href={item.link_url} >
                            <a onClick={(e) => handleClick(e, item, '4free',index)} target={item.link_new_yn === 'Y' ? '_blank' : ''} className="spotModuleLink">
                              <span className="spotModuleImage_w">
                                <img src={item.m_img_url} className="spotModuleImg" alt={item.m_img_attr} />
                                {/* <Image
                                  src={item.m_img_url}
                                  className="spotModuleImg"
                                  layout='fixed'
                                  width={162}
                                  height={258}
                                  quality={props.data.imageQuality || 75}
                                  alt={props.data.m_img_attr}
                                /> */}
                              </span>
                              <div className="spotProgramCont">
                                <strong className="spotProgram-Title">{item.title}</strong>
                              </div>
                            </a>
                          </a>
                        </>
                      )
                  }
                </div>
              );
            })
          }
        </div>
      </div>
    </div>

  );
}
